export const UserPermissions = {
	AuditModule: {
		read: "AuditModule:read",
		create: "AuditModule:create",
		update: "AuditModule:update",
		view: "AuditModule:view",
		delete: "AuditModule:delete",
	},
	CommentModule: {
		read: "CommentModule:read",
		create: "CommentModule:create",
		update: "CommentModule:update",
		view: "CommentModule:view",
		delete: "CommentModule:delete",
	},
	EmailReplacerModule: {
		read: "EmailReplacerModule:read",
		create: "EmailReplacerModule:create",
		update: "EmailReplacerModule:update",
		view: "EmailReplacerModule:view",
		delete: "EmailReplacerModule:delete",
	},
	BankModule: {
		read: "BankModule:read",
		create: "BankModule:create",
		update: "BankModule:update",
		view: "BankModule:view",
		delete: "BankModule:delete",
	},
	CompanyModule: {
		read: "CompanyModule:read",
		create: "CompanyModule:create",
		update: "CompanyModule:update",
		view: "CompanyModule:view",
		delete: "CompanyModule:delete",
	},
	CompanyBankDetailModule: {
		read: "CompanyBankDetailModule:read",
		create: "CompanyBankDetailModule:create",
		update: "CompanyBankDetailModule:update",
		view: "CompanyBankDetailModule:view",
		delete: "CompanyBankDetailModule:delete",
	},
	CustomerModule: {
		read: "CustomerModule:read",
		create: "CustomerModule:create",
		update: "CustomerModule:update",
		view: "CustomerModule:view",
		delete: "CustomerModule:delete",
	},
	InvoiceModule: {
		read: "InvoiceModule:read",
		create: "InvoiceModule:create",
		update: "InvoiceModule:update",
		view: "InvoiceModule:view",
		delete: "InvoiceModule:delete",
	},
	InvoiceItemModule: {
		read: "InvoiceItemModule:read",
		create: "InvoiceItemModule:create",
		update: "InvoiceItemModule:update",
		view: "InvoiceItemModule:view",
		delete: "InvoiceItemModule:delete",
	},
	MarketModule: {
		read: "MarketModule:read",
		create: "MarketModule:create",
		update: "MarketModule:update",
		view: "MarketModule:view",
		delete: "MarketModule:delete",
	},
	MarketRegionModule: {
		read: "MarketRegionModule:read",
		create: "MarketRegionModule:create",
		update: "MarketRegionModule:update",
		view: "MarketRegionModule:view",
		delete: "MarketRegionModule:delete",
	},
	OrderAuditModule: {
		read: "OrderAuditModule:read",
		create: "OrderAuditModule:create",
		update: "OrderAuditModule:update",
		view: "OrderAuditModule:view",
		delete: "OrderAuditModule:delete",
	},
	OrderCallModule: {
		read: "OrderCallModule:read",
		create: "OrderCallModule:create",
		update: "OrderCallModule:update",
		view: "OrderCallModule:view",
		delete: "OrderCallModule:delete",
	},
	OrderChargeModule: {
		read: "OrderChargeModule:read",
		create: "OrderChargeModule:create",
		update: "OrderChargeModule:update",
		view: "OrderChargeModule:view",
		delete: "OrderChargeModule:delete",
	},
	OrderClaimModule: {
		read: "OrderClaimModule:read",
		create: "OrderClaimModule:create",
		update: "OrderClaimModule:update",
		view: "OrderClaimModule:view",
		delete: "OrderClaimModule:delete",
	},
	OrderExaminationModule: {
		read: "OrderExaminationModule:read",
		create: "OrderExaminationModule:create",
		update: "OrderExaminationModule:update",
		view: "OrderExaminationModule:view",
		delete: "OrderExaminationModule:delete",
	},
	OrderFeeModule: {
		read: "OrderFeeModule:read",
		create: "OrderFeeModule:create",
		update: "OrderFeeModule:update",
		view: "OrderFeeModule:view",
		delete: "OrderFeeModule:delete",
	},
	OrderImportModule: {
		read: "OrderImportModule:read",
		create: "OrderImportModule:create",
		update: "OrderImportModule:update",
		view: "OrderImportModule:view",
		delete: "OrderImportModule:delete",
	},
	OrderNotificationModule: {
		read: "OrderNotificationModule:read",
		create: "OrderNotificationModule:create",
		update: "OrderNotificationModule:update",
		view: "OrderNotificationModule:view",
		delete: "OrderNotificationModule:delete",
	},
	OrderInvoiceModule: {
		read: "OrderInvoiceModule:read",
		create: "OrderInvoiceModule:create",
		update: "OrderInvoiceModule:update",
		view: "OrderInvoiceModule:view",
		delete: "OrderInvoiceModule:delete",
	},
	OrderPartnerReviewModule: {
		read: "OrderPartnerReviewModule:read",
		create: "OrderPartnerReviewModule:create",
		update: "OrderPartnerReviewModule:update",
		view: "OrderPartnerReviewModule:view",
		delete: "OrderPartnerReviewModule:delete",
	},
	OrderPaymentModule: {
		read: "OrderPaymentModule:read",
		create: "OrderPaymentModule:create",
		update: "OrderPaymentModule:update",
		view: "OrderPaymentModule:view",
		delete: "OrderPaymentModule:delete",
	},
	OrderPaymentDetailModule: {
		read: "OrderPaymentDetailModule:read",
		create: "OrderPaymentDetailModule:create",
		update: "OrderPaymentDetailModule:update",
		view: "OrderPaymentDetailModule:view",
		delete: "OrderPaymentDetailModule:delete",
	},
	OrderPriceModule: {
		read: "OrderPriceModule:read",
		create: "OrderPriceModule:create",
		update: "OrderPriceModule:update",
		view: "OrderPriceModule:view",
		delete: "OrderPriceModule:delete",
	},
	OrderFieldValueModule: {
		read: "OrderFieldValueModule:read",
		create: "OrderFieldValueModule:create",
		update: "OrderFieldValueModule:update",
		view: "OrderFieldValueModule:view",
		delete: "OrderFieldValueModule:delete",
	},
	OrderFieldModule: {
		read: "OrderFieldModule:read",
		create: "OrderFieldModule:create",
		update: "OrderFieldModule:update",
		view: "OrderFieldModule:view",
		delete: "OrderFieldModule:delete",
	},
	OrderSetupModule: {
		read: "OrderSetupModule:read",
		create: "OrderSetupModule:create",
		update: "OrderSetupModule:update",
		view: "OrderSetupModule:view",
		delete: "OrderSetupModule:delete",
	},
	OrderTimelineModule: {
		read: "OrderTimelineModule:read",
		create: "OrderTimelineModule:create",
		update: "OrderTimelineModule:update",
		view: "OrderTimelineModule:view",
		delete: "OrderTimelineModule:delete",
	},
	VerticalGeneralSetupModule: {
		read: "VerticalGeneralSetupModule:read",
		create: "VerticalGeneralSetupModule:create",
		update: "VerticalGeneralSetupModule:update",
		view: "VerticalGeneralSetupModule:view",
		delete: "VerticalGeneralSetupModule:delete",
	},
	VerticalModule: {
		read: "VerticalModule:read",
		create: "VerticalModule:create",
		update: "VerticalModule:update",
		view: "VerticalModule:view",
		delete: "VerticalModule:delete",
	},
	OrderModule: {
		read: "OrderModule:read",
		create: "OrderModule:create",
		update: "OrderModule:update",
		view: "OrderModule:view",
		delete: "OrderModule:delete",
	},
	PartnerAddressModule: {
		read: "PartnerAddressModule:read",
		create: "PartnerAddressModule:create",
		update: "PartnerAddressModule:update",
		view: "PartnerAddressModule:view",
		delete: "PartnerAddressModule:delete",
	},
	PartnerAuditModule: {
		read: "PartnerAuditModule:read",
		create: "PartnerAuditModule:create",
		update: "PartnerAuditModule:update",
		view: "PartnerAuditModule:view",
		delete: "PartnerAuditModule:delete",
	},
	PartnerBalanceTransactionModule: {
		read: "PartnerBalanceTransactionModule:read",
		create: "PartnerBalanceTransactionModule:create",
		update: "PartnerBalanceTransactionModule:update",
		view: "PartnerBalanceTransactionModule:view",
		delete: "PartnerBalanceTransactionModule:delete",
	},
	PartnerBalanceModule: {
		read: "PartnerBalanceModule:read",
		create: "PartnerBalanceModule:create",
		update: "PartnerBalanceModule:update",
		view: "PartnerBalanceModule:view",
		delete: "PartnerBalanceModule:delete",
	},
	PartnerBillingProfileModule: {
		read: "PartnerBillingProfileModule:read",
		create: "PartnerBillingProfileModule:create",
		update: "PartnerBillingProfileModule:update",
		view: "PartnerBillingProfileModule:view",
		delete: "PartnerBillingProfileModule:delete",
	},
	PartnerBankAccountModule: {
		read: "PartnerBankAccountModule:read",
		create: "PartnerBankAccountModule:create",
		update: "PartnerBankAccountModule:update",
		view: "PartnerBankAccountModule:view",
		delete: "PartnerBankAccountModule:delete",
	},
	PartnerStatisticModule: {
		read: "PartnerStatisticModule:read",
		create: "PartnerStatisticModule:create",
		update: "PartnerStatisticModule:update",
		view: "PartnerStatisticModule:view",
		delete: "PartnerStatisticModule:delete",
	},
	PartnerModule: {
		read: "PartnerModule:read",
		create: "PartnerModule:create",
		update: "PartnerModule:update",
		view: "PartnerModule:view",
		delete: "PartnerModule:delete",
	},
	RepositoriesModule: {
		read: "RepositoriesModule:read",
		create: "RepositoriesModule:create",
		update: "RepositoriesModule:update",
		view: "RepositoriesModule:view",
		delete: "RepositoriesModule:delete",
	},
	UserRolesModule: {
		read: "UserRolesModule:read",
		create: "UserRolesModule:create",
		update: "UserRolesModule:update",
		view: "UserRolesModule:view",
		delete: "UserRolesModule:delete",
	},
	UserModule: {
		read: "UserModule:read",
		create: "UserModule:create",
		update: "UserModule:update",
		view: "UserModule:view",
		delete: "UserModule:delete",
	},
};
